import { fabric } from "fabric";
import { FileType } from "operations/schema/schema";

export const initCanvas = (componentId: string, file: FileType | undefined) => {
  const canvas = new fabric.Canvas(componentId, {
    // Semi-transparent selection so dragging shows a subtle highlight, not an opaque black box.
    selectionBorderColor: "#1976d2",
    selectionColor: "rgba(25, 118, 210, 0.3)",
  });

  const image = new Image();
  // Images load asynchronously, so image.width/height are 0 immediately after setting src.
  // Sizing the canvas and setting the background here (before load) left a black area.
  // Do it in onload, once the real dimensions are known and the image is drawable.
  image.onload = () => {
    try {
      canvas.setWidth(image.width);
      canvas.setHeight(image.height);
      canvas.setBackgroundImage(new fabric.Image(image), canvas.renderAll.bind(canvas));
    } catch {
      // Canvas was disposed before the image finished loading (e.g. React re-mount); ignore.
    }
  };
  image.src = file?.data || "";

  return canvas;
};
